export default class AnimatedCross {
	constructor($section, $element) {
		this.$section = $section;
		this.$element = $element;
	}

	initialize() {
		this.handleAnimation();
		this.$element.addClass('initialized');

		$(window).on('scroll', () => {
			this.handleAnimation();
		});
	}

	handleAnimation() {
		const scrollTop = $(window).scrollTop();
		const windowHeight = $(window).height();
		const sectionTop = this.$section.offset().top - 100;
		const sectionHeight = this.$section.height() + 200;
		const sectionBottom = sectionTop + sectionHeight;

		if (scrollTop + windowHeight > sectionTop && scrollTop < sectionBottom) {
			let scrollPercent = (scrollTop + windowHeight - sectionTop) / (windowHeight + sectionHeight);

			scrollPercent = Math.min(Math.max(scrollPercent, 0), 1);

			if (this.$element.data('start') === 'bottom') {
				scrollPercent = scrollPercent * -1;
			}

			const translateY = scrollPercent * (sectionHeight - 50);
			const rotate = scrollPercent * 180;

			this.$element.css('transform', `translateY(${translateY}px) rotate(${rotate}deg)`);
		}
	}
}
